import ClientLayout from "./ClientLayout";
import { Outlet, useNavigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import { Crown } from "lucide-react";
import { useTranslation } from "react-i18next";
import { Button } from "@shadcn-in-nx/ui/button";
import { Bluelagoon } from "@bluelagoon";
import { toast } from "sonner";
import WorkspaceSwitcher from "../components/WorkspaceSwitcher";

export default function ClientLayoutWrapper() {
    const { isFeatureEnabled, isClient, user } = useAuth();
    const { t } = useTranslation();
    const navigate = useNavigate();
    const hasClientPortalAccess =
        isFeatureEnabled("clientPortal") ||
        user?.company?.id === "cm9vo8axm00d9pa15i3772pqe" ||
        user?.company?.name?.toLowerCase().includes("nsolar") ||
        user?.company?.name?.toLowerCase().includes("baziko") ||
        user?.company?.name?.toLowerCase().includes("waterzone");

    const handleCompanySwitch = async (companyId) => {
        try {
            const response = await Bluelagoon.switchCompany({ companyId });
            const userRole = response.data?.user?.roles?.[0]?.role?.name;
            window.location.href = userRole === "client" ? "/client" : "/";
        } catch (error) {
            console.error("Error switching company:", error);
            toast.error(
                t(
                    "sidebar.workspace.switchError",
                    "Failed to switch workspace. Please try again."
                )
            );
        }
    };

    const hasOtherWorkspaces = (user?.companies?.length || 0) > 1;

    if (!hasClientPortalAccess) {
        return (
            <div className="min-h-screen flex items-center justify-center bg-gray-50 p-4">
                <div className="max-w-md w-full text-center space-y-6">
                    <div className="mx-auto w-16 h-16 rounded-full bg-purple-100 flex items-center justify-center">
                        <Crown className="w-8 h-8 text-purple-600" />
                    </div>
                    <div>
                        <h1 className="text-xl font-semibold text-gray-900">
                            {t("clientPortal.upgradeTitle", "Upgrade Required")}
                        </h1>
                        <p className="mt-2 text-sm text-gray-500">
                            {t(
                                "clientPortal.upgradeDescription",
                                "The Internal Portal is available on Innovator plan ($100/month) and above. Upgrade your plan to give your clients access to their apps and automations."
                            )}
                        </p>
                    </div>
                    {!isClient && (
                        <Button
                            onClick={() => navigate("/billing")}
                            className="bg-purple-600 hover:bg-purple-700"
                        >
                            {t("clientPortal.viewPlans", "View Plans")}
                        </Button>
                    )}
                    {hasOtherWorkspaces && (
                        <div className="pt-4 border-t border-gray-200 text-left">
                            <p className="text-xs text-gray-500 mb-2 text-center">
                                {t(
                                    "clientPortal.switchWorkspacePrompt",
                                    "Or switch to another workspace"
                                )}
                            </p>
                            <WorkspaceSwitcher
                                user={user}
                                onSwitch={handleCompanySwitch}
                            />
                        </div>
                    )}
                </div>
            </div>
        );
    }

    return (
        <ClientLayout>
            <Outlet />
        </ClientLayout>
    );
}
